import { RestaurantContext } from 'Contexts/RestaurantContext';
import React, { useContext } from 'react';

const useRestaurant = () => {
    return useContext(RestaurantContext);
}

export default useRestaurant;